import React from 'react'
import './Header1.css'
import SearchIcon from '@material-ui/icons/Search';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { Link } from 'react-router-dom';
import { useStateValue } from './StateProvider';
import { auth } from './firebase';
import inmar from './Imagenes/inmar.png'
import Sidebar from './Sidebar';

function Header() {
    const[{basket, user },dispatch]= useStateValue();

    const handleAuthentication = () => {
        if (user) {
        auth.signOut();
        }
    }
    return (
        <div className='header1'>
            <Link to="/">
           <img className="header_logo1"
           src= {inmar} />
        </Link>
        <div className="header_search1">
            <input className= "header_searchInput1" type="text1"/>
            <SearchIcon 
            className="header_searchIcon1"/>
        </div>
        <div className= "header_nav1">
            <Link style={{ textDecoration: 'none' }} to={!user && '/login'}>
           <div onClick={handleAuthentication}className= "header_option1">
           <span className= "header_optionLineOne1">
               {!user ? 'Invitado' : user.email} </span>
               <span className= "header_optionLineTwo1">
               {user ? 'Cerrar sesión': 'Iniciar sesión'} </span>
           </div> 
           </Link>
           
           <Link style={{ textDecoration: 'none' }} to='/orders'>
           <div className= "header_option1">
           <span className= "header_optionLineOne1">
               Pedidos </span>
               <span className= "header_optionLineTwo1">
               Ordenes </span>
           </div> 
           </Link>
           <Link style={{ textDecoration: 'none' }} to="/Lista">
           <div className= "header_option1">
           <span className= "header_optionLineOne1">
               Nuestro</span>
               <span className= "header_optionLineTwo1">
               Catálogo</span>
           </div> 
           </Link>
           <Link style={{ textDecoration: 'none' }}to={!user ? '/login':"/checkout" }>
        <div className="header_optionBasket1">
            <ShoppingCartIcon  style={{ fontSize: 36}}/>
            <span className= "header_optionLineTwo1 header_basketCount1">
                {basket?.length}
            </span>
        </div>
        
        </Link>
        
        
        </div>
        
        <Sidebar/>
        </div>
        
    )
}

export default Header
